import { AmazonProduct } from "../src/components/Verticals/Amazon/AmazonProduct";
import { AutoRefinanceCompany } from "../src/components/Verticals/AutoRefinance/AutoRefinanceCompany";
import { AutoWarrantyCompany } from "../src/components/Verticals/AutoWarranty/AutoWarrantyCompany";
import { BestBanksCompany } from "../src/components/Verticals/BestBanks/BestBanksCompany";
import { BusinessBankingCompany } from "../src/components/Verticals/BusinessBanking/BusinessBankingCompany";
import { CreditAssistanceCompany } from "../src/components/Verticals/CreditAssistance/CreditAssistanceCompany";
import { DemoGridTCR } from "../src/components/Verticals/DemoGridTCR/DemoGridTCR";
import { FavyColumns } from "../src/components/Verticals/FavyColumns/FavyColumns";
import { FavyColumnsCoupon } from "../src/components/Verticals/FavyColumns/FavyColumnsCoupon";
import { FavyColumnsPhone } from "../src/components/Verticals/FavyColumns/FavyColumnsPhone";
import { FavyColumnsTrustpilot } from "../src/components/Verticals/FavyColumns/FavyColumnsTrustpilot";
import { FavyColumnsWebWidget } from "../src/components/Verticals/FavyColumns/FavyColumnsWebWidget";
import { FavySoftwareLayout } from "../src/components/Verticals/FavySoftwareLayout/FavySoftwareLayout";
import { FavySoftwareTrustpilot } from "../src/components/Verticals/FavySoftwareLayout/FavySoftwareTrustpilot";
import { FavySoftwareWebWidget } from "../src/components/Verticals/FavySoftwareLayout/FavySoftwareWebWidget";
import { GoldIraCompany } from "../src/components/Verticals/GoldIras/GoldIraCompany";
import { GridLayoutAlpha } from "../src/components/Verticals/GridLayoutAlpha/GridLayoutAlpha";
import { GridLayoutBeta } from "../src/components/Verticals/GridLayoutBeta/GridLayoutBeta";
import { HomeWarrantyCompany } from "../src/components/Verticals/HomeWarranty/HomeWarrantyCompany";
import { IncorporationServicesCompany } from "../src/components/Verticals/IncorporationServices/IncorporationServicesCompany";
import { InsuranceListCompany } from "../src/components/Verticals/InsuranceList/InsuranceListCompany";
import { HealthInsuranceCompany } from "../src/components/Verticals/InsuranceRankedColumns/HealthInsuranceCompany";
import { InsuranceRankedColumns } from "../src/components/Verticals/InsuranceRankedColumns/InsuranceRankedColumns";
import { RentersInsuranceCompany } from "../src/components/Verticals/InsuranceRankedColumns/RentersInsuranceCompany";
import { LifeInsuranceCompany } from "../src/components/Verticals/LifeInsurance/LifeInsuranceCompany";
import { TaxAssistanceCompany } from "../src/components/Verticals/TaxAssistance/TaxAssistanceCompany";
import { AlternativeInvestmentsCompany } from "../src/components/Verticals/TCRColumnLayout/AlternativeInvestmentsCompany";
import { BusinessLoansCompany } from "../src/components/Verticals/TCRColumnLayout/BusinessLoansCompany";
import { CreditMonitoringCompany } from "../src/components/Verticals/TCRColumnLayout/CreditMonitoringCompany";
import { PaydayLoansCompany } from "../src/components/Verticals/TCRColumnLayout/PaydayLoansCompany";
import { SpendManagementCompany } from "../src/components/Verticals/TCRColumnLayout/SpendManagementCompany";
import { TaxPreparationServicesCompany } from "../src/components/Verticals/TCRColumnLayout/TaxPreparationServicesCompany";
import { TCRColumnLayout } from "../src/components/Verticals/TCRColumnLayout/TCRColumnLayout";
import { TCRLegacyLayout } from "../src/components/Verticals/TCRLegacyLayout/TCRLegacyLayout";
import { ALL_CONFIG_VERTICALS, BTR_DOMAIN, TCR_DOMAIN } from "./constants";
import {
	BUSINESS_BANK_ACCOUNTS,
	CDS_PATH,
	CHECKING_ACCOUNTS_PATH,
	SAVINGS_ACCOUNTS_PATH,
} from "./site/bestbanks";
import { CREDIT_ASSISTANCE_PATH } from "./site/bestcreditreviews";
import { GOLD_IRA_PATH } from "./site/bestiras";
import { TAX_ASSISTANCE_PATH } from "./site/besttaxreviews";
import { AUTO_WARRANTY_PATH, HOME_WARRANTY_PATH } from "./site/bestwarranty";
import {
	ACCOUNTS_PAYABLE_PATH,
	BACKGROUND_SEARCH_PATH,
	BUSINESS_PASSWORD_MANAGERS_PATH,
	BUSINESS_VPN_PATH,
	CELL_PHONE_PLANS_PATH,
	COFFEE_CLUBS_PATH,
	DIET_MEAL_PLANS_PATH,
	DNA_TESTING_PATH,
	ELECTRIC_BIKES_PATH,
	ELECTRONIC_SIGNATURE_PATH,
	FLOWER_DELIVERY_PATH,
	GLOBAL_HR_PATH,
	HAIR_GROWTH_PATH,
	INCORPORATION_SERVICES_PATH,
	INVISIBLE_BRACES_PATH,
	LANGUAGE_LEARNING_PATH,
	MATTRESS_TOPPERS_PATH,
	MATTRESSES_PATH,
	MEAL_DELIVERY_PATH,
	MEAT_DELIVERY_SERVICES_PATH,
	PDF_EDITORS_PATH,
	PERSONAL_VPN_PATH,
	PET_FOOD_DELIVERY_PATH,
	PROMOTIONAL_PRODUCTS_PATH,
	SOLAR_PATH,
	SURVEY_SITES_PATH,
	TEA_CLUBS_PATH,
	TEETH_WHITENING_PATH,
	WEBSITE_BUILDERS_PATH,
	WEIGHT_LOSS_PATH,
	WINE_CLUBS_PATH,
} from "./site/favy";
import {
	BUSINESS_INSURANCE_PATH,
	DISABILITY_INSURANCE_DEFAULT_PATH,
	IR_AUTO_INSURANCE_DEFAULT_PATH,
	IR_HEALTH_INSURANCE_DEFAULT_PATH,
	IR_HOMEOWNERS_INSURANCE_DEFAULT_PATH,
	IR_LIFE_INSURANCE_DEFAULT_PATH,
	IR_PET_INSURANCE_DEFAULT_PATH,
	IR_PHONE_INSURANCE_PATH,
	IR_RENTERS_INSURANCE_DEFAULT_PATH,
	TRAVEL_INSURANCE_PATH,
	VISION_INSURANCE_PATH,
} from "./site/insuranceranked";
import { CREDIT_HELP_PATH } from "./site/professorcredit";
import {
	ALTERNATIVE_INVESTMENTS_PATH,
	AUTO_REFINANCE_PATH,
	BILL_NEGOTIATION_PATH,
	BUSINESS_BANKING_PATH,
	BUSINESS_LOANS_DEFAULT_PATH,
	CREDIT_BUILDER_LOANS_DEFAULT_PATH,
	CREDIT_MONITORING_DEFAULT_PATH,
	CREDIT_REPAIR_DEFAULT_PATH,
	DEBT_RELIEF_DEFAULT_PATH,
	FINANCIAL_ADVISORS_PATH,
	IDENTITY_THEFT_PROTECTION_PATH,
	MORTGAGE_REFINANCE_PATH,
	PAYDAY_LOANS_PATH,
	PERSONAL_LOANS_DEFAULT_PATH,
	SHARED_EQUITY_AGREEMENTS_PATH,
	SPEND_MANAGEMENT_PATH,
	STUDENT_LOANS_REFINANCE_DEFAULT_PATH,
	TAX_PREPARATION_SERVICES_PATH,
	TAX_RELIEF_DEFAULT_PATH,
} from "./site/thecreditreview";

export const GRID_LAYOUT_PATHS_WITH_COMPONENTS = {
	/**
	 * Best IRA's (bi)
	 */
	// http://local.bestiras.com/gold-ira
	[GOLD_IRA_PATH]: GoldIraCompany,

	/**
	 * Favy (fvy)
	 */
	// http://local.favy.com/accounts-payable
	[ACCOUNTS_PAYABLE_PATH]: FavySoftwareLayout,
	// http://local.favy.com/background-search
	[BACKGROUND_SEARCH_PATH]: GridLayoutBeta,
	// http://local.favy.com/business-password-managers
	[BUSINESS_PASSWORD_MANAGERS_PATH]: FavySoftwareTrustpilot,
	// http://local.favy.com/business-vpn
	[BUSINESS_VPN_PATH]: FavySoftwareWebWidget,
	// http://local.favy.com/cell-phone-plans
	[CELL_PHONE_PLANS_PATH]: FavyColumnsCoupon,
	// http://local.favy.com/coffee-clubs
	[COFFEE_CLUBS_PATH]: GridLayoutBeta,
	// http://local.favy.com/diet-meal-plans
	[DIET_MEAL_PLANS_PATH]: GridLayoutBeta,
	// http://local.favy.com/dna-testing
	[DNA_TESTING_PATH]: GridLayoutBeta,
	// http://local.favy.com/electric-bikes
	[ELECTRIC_BIKES_PATH]: GridLayoutBeta,
	// http://local.favy.com/electronic-signature
	[ELECTRONIC_SIGNATURE_PATH]: FavySoftwareLayout,
	// http://local.favy.com/flower-delivery
	[FLOWER_DELIVERY_PATH]: GridLayoutBeta,
	// http://local.favy.com/global-hr
	[GLOBAL_HR_PATH]: FavySoftwareTrustpilot,
	// http://local.favy.com/hair-growth
	[HAIR_GROWTH_PATH]: GridLayoutBeta,
	// http://local.favy.com/incorporation-services
	[INCORPORATION_SERVICES_PATH]: IncorporationServicesCompany,
	// http://local.favy.com/invisible-braces
	[INVISIBLE_BRACES_PATH]: GridLayoutBeta,
	// http://local.favy.com/language-learning
	[LANGUAGE_LEARNING_PATH]: GridLayoutBeta,
	// http://local.favy.com/mattress-toppers
	[MATTRESS_TOPPERS_PATH]: FavyColumns,
	// http://local.favy.com/mattresses
	[MATTRESSES_PATH]: FavyColumnsTrustpilot,
	// http://local.favy.com/meal-delivery
	[MEAL_DELIVERY_PATH]: GridLayoutBeta,
	// http://local.favy.com/meat-delivery-services
	[MEAT_DELIVERY_SERVICES_PATH]: FavyColumns,
	// http://local.favy.com/pdf-editors
	[PDF_EDITORS_PATH]: FavySoftwareWebWidget,
	// http://local.favy.com/personal-vpn
	[PERSONAL_VPN_PATH]: FavySoftwareWebWidget,
	// http://local.favy.com/pet-food-delivery
	[PET_FOOD_DELIVERY_PATH]: FavyColumnsCoupon,
	// http://local.favy.com/promotional-products
	[PROMOTIONAL_PRODUCTS_PATH]: FavyColumnsWebWidget,
	// http://local.favy.com/solar
	[SOLAR_PATH]: FavyColumnsPhone,
	// http://local.favy.com/survey-sites
	[SURVEY_SITES_PATH]: FavyColumnsTrustpilot,
	// http://local.favy.com/tea-clubs
	[TEA_CLUBS_PATH]: FavyColumnsWebWidget,
	// http://local.favy.com/teeth-whitening
	[TEETH_WHITENING_PATH]: GridLayoutBeta,
	// http://local.favy.com/website-builders
	[WEBSITE_BUILDERS_PATH]: FavySoftwareWebWidget,
	// http://local.favy.com/weight-loss
	[WEIGHT_LOSS_PATH]: GridLayoutBeta,
	// http://local.favy.com/wine-clubs
	[WINE_CLUBS_PATH]: GridLayoutBeta,

	/**
	 * Insurance Ranked (ir)
	 */
	// http://local.insuranceranked.com/business-insurance
	[BUSINESS_INSURANCE_PATH]: GridLayoutAlpha,
	// http://local.insuranceranked.com/disability-insurance
	[DISABILITY_INSURANCE_DEFAULT_PATH]: InsuranceRankedColumns,
	// http://local.insuranceranked.com/auto-insurance
	[IR_AUTO_INSURANCE_DEFAULT_PATH]: InsuranceListCompany,
	// http://local.insuranceranked.com/health-insurance
	[IR_HEALTH_INSURANCE_DEFAULT_PATH]: HealthInsuranceCompany,
	// http://local.insuranceranked.com/homeowners-insurance/
	[IR_HOMEOWNERS_INSURANCE_DEFAULT_PATH]: InsuranceListCompany,
	// http://local.insuranceranked.com/life-insurance
	[IR_LIFE_INSURANCE_DEFAULT_PATH]: LifeInsuranceCompany,
	// http://local.insuranceranked.com/pet-insurance
	[IR_PET_INSURANCE_DEFAULT_PATH]: LifeInsuranceCompany,
	// http://local.insuranceranked.com/phone-insurance
	[IR_PHONE_INSURANCE_PATH]: GridLayoutAlpha,
	// http://local.insuranceranked.com/renters-insurance
	[IR_RENTERS_INSURANCE_DEFAULT_PATH]: RentersInsuranceCompany,
	// http://local.insuranceranked.com/travel-insurance
	[TRAVEL_INSURANCE_PATH]: GridLayoutAlpha,
	// http://local.insuranceranked.com/vision-insurance
	[VISION_INSURANCE_PATH]: GridLayoutAlpha,

	/**
	 * Best Credit Reviews (bcr)
	 */
	// http://local.bestcreditreviews.com/credit-assistance
	[CREDIT_ASSISTANCE_PATH]: CreditAssistanceCompany,

	/**
	 * Best Tax Reviews (btr)
	 */
	// http://local.besttaxreviews.com/tax-assistance
	[TAX_ASSISTANCE_PATH]: TaxAssistanceCompany,
	// http://local.besttaxreviews.com/tax-relief
	[`btr-${TAX_RELIEF_DEFAULT_PATH}`]: TaxAssistanceCompany,

	/**
	 * The Credit Review (tcr)
	 */
	// http://local.thecreditreview.com/alternative-investments
	[ALTERNATIVE_INVESTMENTS_PATH]: AlternativeInvestmentsCompany,
	// http://local.thecreditreview.com/auto-refinance/
	[AUTO_REFINANCE_PATH]: AutoRefinanceCompany,
	// http://local.thecreditreview.com/bill-negotiation
	[BILL_NEGOTIATION_PATH]: CreditMonitoringCompany,
	// http://local.thecreditreview.com/business-banking
	[BUSINESS_BANKING_PATH]: BusinessBankingCompany,
	// http://local.thecreditreview.com/business-loans
	[BUSINESS_LOANS_DEFAULT_PATH]: BusinessLoansCompany,
	// http://local.thecreditreview.com/credit-builder-loans
	[CREDIT_BUILDER_LOANS_DEFAULT_PATH]: TCRLegacyLayout,
	// http://local.thecreditreview.com/credit-monitoring
	[CREDIT_MONITORING_DEFAULT_PATH]: CreditMonitoringCompany,
	// http://local.thecreditreview.com/credit-repair
	[CREDIT_REPAIR_DEFAULT_PATH]: TCRLegacyLayout,
	// http://local.thecreditreview.com/debt-relief
	[DEBT_RELIEF_DEFAULT_PATH]: TCRLegacyLayout,
	// http://local.thecreditreview.com/financial-advisors
	[FINANCIAL_ADVISORS_PATH]: TCRLegacyLayout,
	// http://local.thecreditreview.com/identity-theft-protection
	[IDENTITY_THEFT_PROTECTION_PATH]: CreditMonitoringCompany,
	// http://local.thecreditreview.com/mortgage-refinance
	[MORTGAGE_REFINANCE_PATH]: TCRColumnLayout,
	// http://local.thecreditreview.com/payday-loans
	[PAYDAY_LOANS_PATH]: PaydayLoansCompany,
	// http://local.thecreditreview.com/personal-loans
	[PERSONAL_LOANS_DEFAULT_PATH]: TCRColumnLayout,
	// http://local.thecreditreview.com/shared-equity-agreements
	[SHARED_EQUITY_AGREEMENTS_PATH]: CreditMonitoringCompany,
	// http://local.thecreditreview.com/spend-management
	[SPEND_MANAGEMENT_PATH]: SpendManagementCompany,
	// http://local.thecreditreview.com/student-loan-refinance
	[STUDENT_LOANS_REFINANCE_DEFAULT_PATH]: TCRColumnLayout,
	// http://local.thecreditreview.com/tax-preparation-services
	[TAX_PREPARATION_SERVICES_PATH]: TaxPreparationServicesCompany,
	// http://local.thecreditreview.com/tax-relief
	[`tcr-${TAX_RELIEF_DEFAULT_PATH}`]: TCRLegacyLayout,

	/**
	 * Professor Credit (pc)
	 */
	// http://local-help.professorcredit.com/credit-help
	[CREDIT_HELP_PATH]: TCRLegacyLayout,

	/**
	 * Best Warranty (bw)
	 */
	// http://local.bestwarranty.com/auto-warranty
	[AUTO_WARRANTY_PATH]: AutoWarrantyCompany,
	// http://local.bestwarranty.com/home-warranty
	[HOME_WARRANTY_PATH]: HomeWarrantyCompany,

	/**
	 * Best Banks (bb)
	 */
	// http://local.bestbanks.com/savings-accounts
	[SAVINGS_ACCOUNTS_PATH]: BestBanksCompany,
	// http://local.bestbanks.com/cds
	[CDS_PATH]: BestBanksCompany,
	// http://local.bestbanks.com/business-banking
	[BUSINESS_BANK_ACCOUNTS]: BestBanksCompany,
	// http://local.bestbanks.com/checking-accounts
	[CHECKING_ACCOUNTS_PATH]: BestBanksCompany,
};

const FAVY_FIXED_WIDTH_LAYOUT_COMPONENTS = [
	FavySoftwareLayout,
	FavySoftwareTrustpilot,
	FavySoftwareWebWidget,
	GridLayoutBeta,
	IncorporationServicesCompany,
];

const getVerticalsByComponents = (components) =>
	Object.entries(GRID_LAYOUT_PATHS_WITH_COMPONENTS)
		.filter(([, layout]) => components.includes(layout))
		.map(([vertical]) => vertical);

export const FIXED_WIDTH_CARD_VERTICALS = [
	// Favy
	...getVerticalsByComponents(FAVY_FIXED_WIDTH_LAYOUT_COMPONENTS),
	// Insurance Ranked
	IR_LIFE_INSURANCE_DEFAULT_PATH,
	IR_PET_INSURANCE_DEFAULT_PATH,
	VISION_INSURANCE_PATH,
	IR_PHONE_INSURANCE_PATH,
	TRAVEL_INSURANCE_PATH,
	BUSINESS_INSURANCE_PATH,
	// Best Credit Reviews
	CREDIT_ASSISTANCE_PATH,
	// Best Tax Reviews
	TAX_ASSISTANCE_PATH,
	// Best Warranty
	AUTO_WARRANTY_PATH,
	HOME_WARRANTY_PATH,
];

export const DEFAULT_GRID_LAYOUT = GridLayoutBeta;

export const getGridLayoutForVertical = (vertical, isAmazonVertical) => {
	if (isAmazonVertical) {
		return AmazonProduct;
	}

	// if 'vertical' is not defined anywhere amongst the keys of all the vertical site configs OR within the grid config, then fallback to rendering a grid config
	if (!ALL_CONFIG_VERTICALS.includes(vertical)) {
		return DOMAIN === TCR_DOMAIN ? DemoGridTCR : DEFAULT_GRID_LAYOUT;
	}

	// Check for domain-specific component first (for tax-relief path)
	if (vertical === TAX_RELIEF_DEFAULT_PATH) {
		const domainKey =
			DOMAIN === BTR_DOMAIN ? `btr-${vertical}` : `tcr-${vertical}`;

		return GRID_LAYOUT_PATHS_WITH_COMPONENTS?.[domainKey] ?? null;
	}

	return GRID_LAYOUT_PATHS_WITH_COMPONENTS?.[vertical] ?? null;
};
